import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import useUser from "../../../../../hooks/useUser";
import { CgDanger } from "react-icons/cg";
import { Container, Tooltip } from "react-bootstrap";
import ErrorTooltip from "../ErrorTooltip";
import { debugModule } from "../../../../../api/apiDebug";
import { myId } from "../../../../../lib/MyLibrary";
import SelectEstado from "./SelectEstado";
import SelectCity from "./SelectCity";
import {useMediaQuery} from 'react-responsive';


const MESES = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];
const BOTTOMYEAR = 1940;
let YEARS = [];
let today = new Date();
let actualYear = today.getFullYear();

for (let i = actualYear - 10; i > BOTTOMYEAR; i--) YEARS.push(i);

let DAYS = [];

for (let i = 0; i < 31; i++) DAYS.push(i + 1);

const myRegExp = /^[a-záéíóúÁÉÍÓÚñÑ ,.'-]+$/i;

const PersonalData = () => {
  const [dataUser, setDataUser] = useUser();
  const {
    email,
    nameUser,
    paterno,
    materno,
    gender,
    maritalStatus,
    zipCode,
    cityUser,
    stateUser,
  } = dataUser;

  const [fenac, setFenac] = useState({
    days: DAYS,
    months: MESES,
    years: YEARS,
  });
  const [myFenac, setMyFenac] = useState({
    day: "",
    month: "",
    year: "",
  });
  const [showValidateZipCode, setShowValidateZipCode] = useState(false);
  const [isValidFenac, setIsValidFenac] = useState(false);
  const [isValidNameUser, setIsValidNameUser] = useState(false);
  const [isValidPaterno, setIsValidPaterno] = useState(false);
  const [isValidMaterno, setIsValidMaterno] = useState(false);
  const [isValidCityUser, setIsValidCityUser] = useState(false);
  const [isValidStateUser, setIsValidStateUser] = useState(false);
  const [estadoSelected, setEstadoSelected] = useState('');
  const [errorCity, setErrorCity] = useState(false);
  //const [isMobile, setIsMobile] = useState(false);

  const isMobile = useMediaQuery({ query: `(max-width: 400px)` });

  useEffect(() => {
    //console.log('estados:..',estados);
    //initView();
  }, []);

  


  const actualizaUserFenac = () => {
    let mes =MESES.indexOf(myFenac.month);
    
    /*if (mes === "Ene") mes = "Jan";
    if (mes === "Abr") mes = "Apr";
    if (mes === "Ago") mes = "Aug";
    if (mes === "Dic") mes = "Dec";*/
    //let tempDate = new Date(`${myFenac.year}/${mes}/${myFenac.day}`);
    let tempDate = new Date();
    tempDate.setFullYear(parseInt(myFenac.year,10));
    tempDate.setMonth(mes);
    //console.log('mes:...',mes);
    tempDate.setDate(parseInt(myFenac.day,10));
    //sendDataDebug({msg:'actualizandoUserFenac',myFenac,tempDate})
    //console.log('estableciendo la fecha:',myFenac,tempDate);
    return tempDate;
  };

  /*useEffect(() => {
    if(myFenac.day!==''){
      console.log('myFenac.day',myFenac.day);
      sendDataDebug({name:'myFenac.day',value:myFenac.day})
    }
    if(myFenac.month!==''){
      console.log('myFenac.day',myFenac.month);
      sendDataDebug({name:'myFenac.month',value:myFenac.month})
    }
    if(myFenac.year!==''){
      console.log('myFenac.day',myFenac.year);
      sendDataDebug({name:'myFenac.year',value:myFenac.year})
    }
  
  }, [myFenac])*/
  

  useEffect(() => {
    if (dataUser.nameUser) validateNameUSer();
    if (dataUser.paterno) validatePaterno();
    
    

    

    if (myFenac.month !== "") {
      let res = checkMonth(myFenac.month);
      if (
        res &&
        myFenac.day !== "" &&
        myFenac.month !== "" &&
        myFenac.year !== ""
      ) {
        //sendDataDebug({msg:'Validando UserFenac:...'})
        setIsValidFenac(true);
        setDataUser({
          ...dataUser,
          userFenac: actualizaUserFenac(),
          isValidFenac: true,
        });
      }
    }

    if (
      myFenac.day === "" ||
      myFenac.day === "Choose..." ||
      myFenac.month === "" ||
      myFenac.month === "Choose..." ||
      myFenac.year === "" ||
      myFenac.year === "Choose..."
    ) {
      setIsValidFenac(false);
      setDataUser({
        ...dataUser,
        isValidFenac: false,
      });
    }
    
  }, [
    myFenac.day,
    myFenac.month,
    myFenac.year,
    dataUser.nameUser,
    dataUser.paterno,
    
  ]);

  useEffect(() => {
    validateZipCode(dataUser.zipCode);

    setDataUser({
      ...dataUser,
      isValidNameUser,
      isValidPaterno,
      isValidMaterno,
      isValidZipCode: !showValidateZipCode,
      isValidCityUser,
      isValidStateUser,
      isValidFenac
    });

    
  }, [
    dataUser.zipCode,
    isValidNameUser,
    isValidPaterno,
    isValidMaterno,
    showValidateZipCode,
    isValidCityUser,
    isValidStateUser,
    isValidFenac
  ]);

  useEffect(()=>{
    //if(dataUser.isValidFenac) 
    //sendDataDebug({data:'dataUser.userFenac',value:String(dataUser.userFenac)});
  },[dataUser.isValidFenac,dataUser.userFenac])

  useEffect(()=>{
    //console.log('Datos del formulario:....',dataUser)
    if(!isValidCityUser) validateCityUser();
    if(!isValidNameUser) validateNameUSer();
    if(!isValidMaterno) validateMaterno();
    if(!isValidPaterno) validatePaterno();
    if(!isValidStateUser) validateStateUser();
    if(showValidateZipCode) validateZipCode(dataUser.zipCode);
  },[dataUser])

  useEffect(()=>{
    //console.log('UseEffect cityUser:...',cityUser);
    validateCityUser();
  
  },[dataUser.cityUser])
  useEffect(()=>{
    //console.log('UseEffect stateUser:...',stateUser);
    validateStateUser();
  },[dataUser.stateUser])

  const validateNameUSer = () => {
    const result = myRegExp.test(dataUser?.nameUser?.trim());

    if (
      dataUser?.nameUser?.trim().length > 1 &&
      dataUser?.nameUser?.trim().length < 21 &&
      result
    ) {
      setIsValidNameUser(true);
    } else {
      setIsValidNameUser(false);
    }
    //console.log('Result:..',result);
    return;
  };
  const validatePaterno = () => {
    const result = myRegExp.test(dataUser?.paterno?.trim());

    if (
      dataUser?.paterno?.trim().length > 1 &&
      dataUser?.paterno?.trim().length < 41 &&
      result
    )
      setIsValidPaterno(true);
    else setIsValidPaterno(false);

    //console.log('Result:..',result);
    return;
  };
  const validateMaterno = () => {
    const result = myRegExp.test(dataUser?.materno?.trim());

    if (
      dataUser?.materno?.trim().length > 1 &&
      dataUser?.materno?.trim().length < 41 &&
      result
    )
      setIsValidMaterno(true);
    else setIsValidMaterno(false);

    //console.log('Result:..',result);
    return;
  };
  const validateCityUser = () => {

    if(!dataUser.cityUser||
      dataUser.cityUser===''||
      dataUser.cityUser===undefined||
      dataUser.cityUser===null||
      dataUser.cityUser==='elegir'
      ){
      setIsValidCityUser(false);
    } else{
      setIsValidCityUser(true);
    }

    
    return;
  };

  const validateStateUser = () => {
    if(!dataUser.stateUser||
      dataUser.stateUser===''||
      dataUser.stateUser===undefined||
      dataUser.stateUser===null||
      dataUser.stateUser==='elegir'
      ){
        setIsValidStateUser(false);
      
    } else{
      setIsValidStateUser(true);
      
    }
    return;
  };

  const handleChange = (e) => {
    setDataUser({
      ...dataUser,
      [e.target.name]: e.target.value,
    });
    //console.log(`${e.target.name}: ${e.target.value}`)
    if (dataUser.nameUser) validateNameUSer();
    if (dataUser.paterno) validatePaterno();
  };

  const setTopDays = (days) => {
    let tempDays = [];
    for (let i = 0; i < days; i++) tempDays.push(i + 1);
    setFenac({
      ...fenac,
      days: tempDays,
    });
  };

  const checkMonth = (mes) => {
    //console.log('Checando el mes:',mes);
    if (mes === "Feb") {
      if (myFenac.year !== "") {
        if (
          (parseInt(myFenac.year) % 4 === 0 &&
            parseInt(myFenac.year) % 100 !== 0) ||
          parseInt(myFenac.year) % 400 === 0
        ) {
          setTopDays(29);
          if (myFenac.day !== "" && myFenac.day > 29)
            setMyFenac({
              ...myFenac,
              day: 29,
            });
          return true;
        } else {
          setTopDays(28);
          if (myFenac.day !== "" && myFenac.day > 28)
            setMyFenac({
              ...myFenac,
              day: 28,
            });
          return true;
        }
      } else {
        setTopDays(28);
        if (myFenac.day !== "" && myFenac.day > 28)
          setMyFenac({
            ...myFenac,
            day: 28,
          });
        return true;
      }
    } else if (
      mes === "Abr" ||
      mes === "Jun" ||
      mes === "Sep" ||
      mes === "Nov"
    ) {
      setTopDays(30);
      if (myFenac.day !== "" && myFenac.day > 30)
        setMyFenac({
          ...myFenac,
          day: 30,
        });
      return true;
    } else {
      setTopDays(31);
      return true;
    }
  };

  const sendDataDebug = async(data)=>{
    try {
      const result = await debugModule(data);
      console.log('resultDebug(front-back):..',result);
    } catch (error) {
      console.log(error);
    }
  }

  const handleFenac = async(e) => {
    //console.log("selected year...", e.target.value);

    
    const myData = {
      name: e.target.name,
      value: e.target.value
    }
    //await sendDataDebug(myData);
    if (myFenac.month !== "") checkMonth(myFenac.month);
    if (myData.name === "month") {
      if (checkMonth(myData.value)) {
        //console.log('ingresando Fenac:..',myData.name,myData.value);
        setMyFenac({
          ...myFenac,
          [myData.name]: myData.value,
        });
      } else {
        console.log("no se pudo checar el mes...");
      }
    } else {
      //console.log('ingresando Fenac:..',myData.name,myData.value); 
      setMyFenac({
        ...myFenac,
        [myData.name]: myData.value,
      });
    }
  };

  const validateZipCode = (myZipCode) => {
    let numbers = "0123456789";
    let content = zipCode?.split("") || [""];
    let search = content.map((el) => numbers.includes(el));
    let res = search.find((el) => el === false);

    if ((res === undefined && zipCode?.length === 5) || !zipCode) {
      setShowValidateZipCode(false);
      return true;
    } else {
      setShowValidateZipCode(true);
      return false;
    }
  };
  const handleChangeEstado = (data) => {
    //console.log('dataEstado:...',data);
    setDataUser({
      ...dataUser,
      stateUser: data,
    })
  }
  const handleChangeCiudad = (data) => {
    //console.log('Cambiando el valor de dataCiudad:...',data);

    setDataUser({
      ...dataUser,
      cityUser: data,
    })
  }

  //console.log("gender:", dataUser.gender);
  return (
    <div style={{ borderLeft: "1px solid #bbbbbb50" }} className="ps-1 w-100">
      <Form>
        {/* <Form.Group className="mb-3 nombre" controlId="formGridNames">
          <Form.Label>Nombre(s)</Form.Label>
          <Container fluid className="d-flex">
            <Form.Control
              value={nameUser ? nameUser : ""}
              name="nameUser"
              onChange={handleChange}
              placeholder="Nombre(s)"
            />
            {!isValidNameUser && <ErrorTooltip msg={"Capturar 2-20 letras"} />}
          </Container>
        </Form.Group> */}
        <Row className="mb-3 apellidos">
          <Form.Group as={Col} controlId="formGridNombre">
            <Form.Label className="text-muted">Nombre(s):</Form.Label>
            <Container className="d-flex">
              <Form.Control
                value={nameUser? nameUser : ""}
                name="nameUser"
                onChange={handleChange}
                placeholder="Nombre(s)"
              />
              {!isValidNameUser && <ErrorTooltip msg={"Capturar 2-40 letras"} />}
            </Container>
          </Form.Group>

          <Form.Group as={Col} controlId="formGridMaterno">
            <Form.Label className="text-muted">Apellido(s):</Form.Label>
            <Container className="d-flex">
              <Form.Control
                value={paterno ? paterno : ""}
                name="paterno"
                onChange={handleChange}
                placeholder="Apellido(s)"
              />
              {!isValidPaterno && <ErrorTooltip msg={"Capturar 2-40 letras"} />}
            </Container>
          </Form.Group>
        </Row>

        <Form.Group className="mb-3 correo" controlId="formGridEmail">
          <Form.Label className="text-muted">Email</Form.Label>
          <Form.Control
            value={email ? email : ""}
            name="email"
            onChange={handleChange}
            type="email"
            placeholder="Email"
            disabled
          />
        </Form.Group>

        <Row className="mb-3 fechaNacimiento">
        <Container className="d-flex">
            <Form.Text id="birthDate" muted>
              Fecha de Cumpleaños:
            </Form.Text>
            {!isValidFenac && <ErrorTooltip msg={"Fecha incorrecta"} />}
          </Container>
          <Form.Group as={Col} controlId="formGridDay">
            <Form.Label>Día</Form.Label>
            <Form.Select
              name="day"
              id="day"
              value={myFenac.day ? myFenac.day : ""}
              onChange={handleFenac}
            >
              <option>Choose...</option>
              {fenac.days.map((day) => (
                <option key={myId()} value={day}>{day}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group as={Col} controlId="formGridMonth">
            <Form.Label>Mes</Form.Label>
            <Form.Select
              name="month"
              id="month"
              value={myFenac.month ? myFenac.month : ""}
              onChange={handleFenac}
            >
              <option>Choose...</option>
              {fenac.months.map((month) => (
                <option key={myId()} value={month}>{month}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group as={Col} controlId="formGridYear">
            <Form.Label>Año</Form.Label>
            <Form.Select
              name="year"
              id="year"
              value={myFenac.year ? myFenac.year : ""}
              onChange={handleFenac}
            >
              <option>Choose...</option>
              {fenac.years.map((year) => (
                <option key={myId()} value={year}>{year}</option>
              ))}
            </Form.Select>
          </Form.Group>
          
        </Row>
        <Row className="genero">
          <Container className="d-flex">
            <Form.Text id="gender" muted>
              Género:
            </Form.Text>
            
          </Container>
          <Col>
            <Form.Group className="mb-3" id="formGridGender">
              <Form.Check
                value="male"
                name="gender"
                checked={gender === "male" ? true : false}
                onChange={handleChange}
                type="radio"
                label="Hombre"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" id="formGridGender">
              <Form.Check
                value="female"
                name="gender"
                checked={gender === "female" ? true : false}
                onChange={handleChange}
                type="radio"
                label="Mujer"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" id="formGridGender">
              <Form.Check
                value="other"
                name="gender"
                checked={gender === "other" ? true : false}
                onChange={handleChange}
                type="radio"
                label={isMobile? "Otro":"Prefiero no decirlo"}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="estadoCivil">
          <Form.Text id="maritalStatus" muted>
            Estado Civil
          </Form.Text>
          <Col>
            <Form.Group className="mb-3" id="formGridSingle">
              <Form.Check
                value="single"
                name="maritalStatus"
                checked={maritalStatus === "single" ? true : false}
                onChange={handleChange}
                type="radio"
                label="Soltero(a)"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" id="formGridMarried">
              <Form.Check
                value="married"
                name="maritalStatus"
                checked={maritalStatus === "married" ? true : false}
                onChange={handleChange}
                type="radio"
                label="Casado(a)"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="codigoPostal">
          <Col className="d-none" xs={6} sm={6} md={6}>
            <Form.Group className="mb-3 w-100" controlId="formGridZipCode">
              <Container className="d-flex w-100">
                <Form.Label className="">Código Postal:</Form.Label>
                {showValidateZipCode && (
                  <ErrorTooltip msg={"Codigo Postal incorrecto"} />
                )}
              </Container>
              <Form.Control
                value={zipCode ? zipCode : ""}
                name="zipCode"
                onChange={handleChange}
                placeholder="Código Postal"
              />
            </Form.Group>
          </Col>
          <Col xs={6} sm={6} md={6}>
          <Container className="d-flex w-100">
            <Form.Label className="me-2 text-muted">Estado:</Form.Label>
            {!isValidStateUser && <ErrorTooltip msg={"Capturar 2-40 letras"} />}
          </Container>
            <SelectEstado setEstadoSelected={setEstadoSelected} handleChangeEstado={handleChangeEstado}/>
            
            </Col>
            <Col xs={6} sm={6} md={6}>
            <Container className="d-flex w-100">
                <Form.Label className="me-2 text-muted">Ciudad:</Form.Label>
                {!isValidCityUser && (
                  <ErrorTooltip msg={"Capturar 2-40 letras"} />
                )}
              </Container>
            <SelectCity 
            errorCity={errorCity}
            setErrorCity={setErrorCity}
            estado={estadoSelected} handleChangeCiudad={handleChangeCiudad}/>
            </Col>
          {errorCity && <p className="text-danger small text-center opacity-75">Favor de Elegir primero el estado</p>}
          <Col xs={6} sm={6} md={6} className="d-none">
            <Form.Group className="mb-3 w-100" controlId="formGridCity">
              <Container className="d-flex w-100">
                <Form.Label className="me-2">Ciudad:</Form.Label>
                {!isValidCityUser && (
                  <ErrorTooltip msg={"Capturar 2-40 letras"} />
                )}
              </Container>
              <Form.Control
                value={cityUser ? cityUser : ""}
                name="cityUser"
                onChange={handleChange}
                placeholder="ciudad"
              />
            </Form.Group>
          </Col>
          <Col xs={6} sm={6} md={6} className="d-none">
          <Form.Group className="mb-3 w-100" controlId="formGridState">
          <Container className="d-flex w-100">
            <Form.Label className="me-2">Estado:</Form.Label>
            {!isValidStateUser && <ErrorTooltip msg={"Capturar 2-40 letras"} />}
          </Container>
          <Form.Control
            value={stateUser ? stateUser : ""}
            name="stateUser"
            onChange={handleChange}
            placeholder="estado"
          />
        </Form.Group>
          </Col>
        </Row>

        
      </Form>
    </div>
  );
};

export default PersonalData;
